import { InfoError } from "@assets";
import { Row } from "@components/Flex";
import { Spacing, SpacingSizes } from "@components/Spacing";
import { Body, Title4 } from "@components/Typography";
import { i18n, Translations } from "@i18n";
import { styles } from "./styles";

export const NoDataDisclaimer = () => {
  return (
    <Row style={styles.disclaimer}>
      <InfoError />
      <div style={styles.disclaimerInner}>
        <Title4>{i18n.t(Translations.PerformanceChartPlaceholderNotEnoughData)}</Title4>
        <Spacing size={SpacingSizes.XXS} />
        <Body>{i18n.t(Translations.PerformanceChartPlaceholderAutomaticUpdate)}</Body>
      </div>
    </Row>
  );
};
